export default __webpack_public_path__ + "static/media/me.7faccce0.png";